import * as React from "react";
import { Grid, Button, Modal, Title, Divider, ActionIcon, Text } from "@mantine/core";
import { BuilderContext, useDrawer } from "react-flow-builder";
import { useForm, useFieldArray, useWatch } from "react-hook-form";
import { object, string, number, date, array, setLocale } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ReportActionType, ReportActionSchema } from "@supportinitiative/common";
import { IconPlus, IconTrash } from "@tabler/icons-react";
import { CMultiSelect, CRadioGroup, CSelect, CTextarea, CTextInput } from "@supportinitiative/react-hook-form-mantine";

import { ReconsetCVMContext } from "../../ReconsetCVM";
import { getSystemStatus, getConfirmationStatus } from "../../ReconsetUtils";
import Where from "../QueryMatch/Where";
import { getId } from "../../../utilities";

function Report() {
  const { state: reconsetFormState } = React.useContext(ReconsetCVMContext);

  const { selectedNode: node } = React.useContext(BuilderContext);
  const { closeDrawer: cancel, saveDrawer: save } = useDrawer();

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm<ReportActionType>({
    defaultValues: node?.data || {
      name: "",
      export: "EXCEL",
      dataPopulation: [],
    },
    criteriaMode: "all",
    resolver: yupResolver(ReportActionSchema),
  });

  const dataPopulation = useFieldArray({
    control,
    name: "dataPopulation",
  });

  return (
    <Modal centered size={"xl"} opened={true} onClose={cancel} title={<Title order={3}>Report</Title>}>
      <Grid align="stretch" gutter={"xs"} mb="xs">
        <Grid.Col span={12}>
          <CTextInput
            name={`name`}
            control={control}
            showErrorText={false}
            label="Name"
            required
            disabled={node?.disabled || false}
          />
        </Grid.Col>
      </Grid>

      <Grid align="stretch" gutter={"xs"} mb="xs">
        <Grid.Col span={12}>
          <CSelect
            name={`export`}
            control={control}
            data={[
              {
                label: "Excel",
                value: "EXCEL",
              },
              {
                label: "CSV",
                value: "CSV",
              },
            ]}
            showErrorText={false}
            label="Export"
            searchable
            clearable
            required
            disabled={reconsetFormState.actionOptions.disableAll}
          />
        </Grid.Col>
      </Grid>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // borderTop: "2px solid #ccc",
          // paddingTop: "20px",
          // width: "90%",
        }}
      >
        <Divider my="xs" label="Data Population" labelPosition="center" />

        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Text fw={500} style={{ fontSize: "14px" }}>
            Rows
          </Text>
          <ActionIcon
            size="sm"
            variant="white"
            color="gray"
            onClick={() => {
              dataPopulation.append({
                name: "",
                genFunction: "",
                id: getId(),
              });
            }}
            disabled={reconsetFormState.actionOptions.disableAll}
          >
            <IconPlus />
          </ActionIcon>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {dataPopulation.fields.map((field, index) => {
            return (
              <Grid align="stretch" gutter={"xs"} mb="xs" key={field.id}>
                <Grid.Col span={3}>
                  <CTextInput
                    name={`dataPopulation.${index}.name`}
                    control={control}
                    label={"Name"}
                    disabled={reconsetFormState.actionOptions.disableAll}
                    required
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <CTextarea
                    name={`dataPopulation.${index}.genFunction`}
                    control={control}
                    label={"Generate Function"}
                    minRows={4}
                    disabled={reconsetFormState.actionOptions.disableAll}
                    required
                  />
                </Grid.Col>
                <Grid.Col span={2}>
                  <CTextInput name={`dataPopulation.${index}.id`} control={control} label={"Id"} disabled={true} />
                </Grid.Col>
                <Grid.Col span={1} style={{ display: "flex", alignItems: "flex-end" }}>
                  <ActionIcon
                    size="sm"
                    variant="white"
                    color="gray"
                    onClick={() => {
                      dataPopulation.remove(index);
                    }}
                    disabled={reconsetFormState.actionOptions.disableAll}
                  >
                    <IconTrash />
                  </ActionIcon>
                </Grid.Col>
              </Grid>
            );
          })}
        </div>
      </div>

      <Grid align="stretch" gutter={"xs"} mt="xl">
        <Grid.Col span={2}>
          <Button
            color="teal"
            variant="filled"
            fullWidth
            type="submit"
            onClick={
              node?.disabled
                ? () => {
                    cancel();
                  }
                : async (event: React.MouseEvent<HTMLButtonElement>) => {
                    event.preventDefault();
                    const values = getValues();
                    clearErrors();
                    try {
                      await ReportActionSchema.validate(values, {
                        abortEarly: false,
                      });

                      save?.(values);
                      //cancel();
                    } catch (error) {
                      console.log("Save error =>", error);
                      console.log("Save error =>", JSON.stringify(error));
                      (error as any).inner.forEach((err: any) => {
                        setError(err.path, {
                          type: "custom",
                          message: err.message,
                        });
                      });
                    }
                  }
            }
          >
            Ok
          </Button>
        </Grid.Col>
      </Grid>
    </Modal>
  );
}

export default Report;
